import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./components/Login";
import Users from "./pages/Users";
import AddUser from "./pages/AddUser";
import EditUser from "./pages/EditUser";
import Registrations from "./pages/Registrations";
import AddRegistration from "./pages/AddRegistration";
import Home from "./pages/Home";
import PublicForm from "./components/PublicForm";
import QRinfo from "./components/QRinfo";
import TermsAndConditions from "./pages/TermsAndConditions";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          
          <Route path="/users" element={<Users />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/edit/:id" element={<EditUser />} />
  
          <Route path="/registrations" element={<Registrations />} />
          <Route path="/registrations/add" element={<AddRegistration />} />
          <Route path="/terms&conditions" element={<TermsAndConditions />} />
          
          <Route path="/registration" element={<PublicForm />} />
          <Route path="/qrinfo" element={<QRinfo />} />
          <Route path="/qrinfo/:id" element={<QRinfo />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
